import { useEffect, useState } from 'react';
import List from '@pelckmans/elementis/components/list';
import { useTranslation } from 'react-i18next';

export type CheckboxState = 'unchecked' | 'checked' | 'indeterminate';

export interface ListEntity {
  id: string;
  title: string;
}

interface Props {
  translationKeyBase: string;
  group: ListEntity;
  members: ListEntity[];
  defaultCollapsed: boolean;
  groupCheckboxState: CheckboxState;
  handleMemberClick: (memberId: string, groupId: string) => void;
  handleGroupClick: (groupId: string) => void;
  getCheckboxState: (memberId: string, groupId: string) => CheckboxState;
}

export default function GroupListHierarchy({
  translationKeyBase,
  group,
  groupCheckboxState,
  members,
  defaultCollapsed,
  handleMemberClick,
  handleGroupClick,
  getCheckboxState,
}: Props) {
  const { t } = useTranslation();

  const [collapsed, setCollapsed] = useState(defaultCollapsed);

  useEffect(() => {
    setCollapsed(defaultCollapsed);
  }, [defaultCollapsed]);

  return (
    <>
      <List.Item
        as="checkbox"
        key={group.id}
        collapsed={collapsed}
        onToggleCollapse={() => setCollapsed(!collapsed)}
        collapseButtonLabelText={t(`${translationKeyBase}.BODY.COLLAPSE_BUTTON`, { groupName: group.title })}
        level={0}
        title={group.title}
        checked={groupCheckboxState === 'checked'}
        indeterminate={groupCheckboxState === 'indeterminate'}
        onClick={() => handleGroupClick(group.id)}
      />
      {!collapsed &&
        members.map(member => (
          <List.Item
            as="checkbox"
            key={member.id}
            // 2, not 1: the class row spends a column on its collapse control
            level={2}
            title={member.title}
            checked={getCheckboxState(member.id, group.id) === 'checked'}
            onClick={() => handleMemberClick(member.id, group.id)}
          />
        ))}
    </>
  );
}
